import { useMemo } from 'react'

import { useActiveOrg } from '~/hooks/org'
import { useAuthUser } from '~/hooks/useAuthUser'

export const useOnboarding = () => {
  const { user } = useAuthUser()
  const { org: activeOrg, isFetchedAfterMount } = useActiveOrg()

  const numWorkspaceOrgs = user?.orgs.filter(
    (org) => org.isPersonal === false,
  ).length

  const isActiveOrgOnboarding =
    !!activeOrg &&
    !activeOrg.isPersonal &&
    activeOrg.smartAccountSetup?.currentStep !== 'COMPLETED' &&
    activeOrg.smartAccountSetup?.currentStep !== 'SKIPPED'

  const isOnboarding = numWorkspaceOrgs === 0 || isActiveOrgOnboarding

  const isFirstOnboarding =
    isOnboarding && (numWorkspaceOrgs === 0 || numWorkspaceOrgs === 1)

  return useMemo(
    () => ({
      isFirstOnboarding,
      isOnboarding,
      isDataLoaded: isFetchedAfterMount,
    }),
    [isFirstOnboarding, isOnboarding, isFetchedAfterMount],
  )
}
